__turbopack_context__.v({
  "active": "ImproveAIButton-module__8y-MfW__active",
  "button": "ImproveAIButton-module__8y-MfW__button",
  "gradientSlide": "ImproveAIButton-module__8y-MfW__gradientSlide",
});
